<template>
  <div class="ly--outer--container bg__banner-bg">
    <div class="ly--content--container relative">
      <ImageWrapper
        src="/assets/images/2025__banner_top_bg.png"
        class="banner__bg"
        alt=""
      />
      <ImageWrapper
        src="/assets/images/addon_bg_mobile_pattern.png"
        class="banner__bg-mobile-pattern"
        alt=""
      />
      <div
        class="title-wrapper w-full relative"
        v-vue-aos.once="{
          animationClass: 'animate__animated animate__fadeIn',
        }"
      >
        <!-- title -->
        <div class="title-section text-left">
          <div class="brand-title fz-35 fw-800 col__nespressoDarkBrown mb-1">
            {{ $t("counter.title.brand") }}
          </div>
          <div
            class="event-title fz-45 fw-700 col__nespressoDarkBrown mb-1 letter-spacing-2"
          >
            {{ $t("counter.title.event") }}
          </div>
          <div class="date-title fz-30 fw-500 col__nespressoDarkBrown">
            {{ $t("counter.title.date") }}
          </div>
        </div>

        <!-- counter -->
        <div class="relative">
          <ImageWrapper
            src="/assets/images/2025/landing_banner_top_mobile.png"
            class="banner__top-mobile"
            alt=""
          />
          <counter
            :endTime="endTime"
            v-if="stage === 'inSale' || stage === 'beforeSale'"
            @end="handleCounterEnd"
            v-vue-aos.once="{
              animationClass: 'animate__animated animate__slideInDown',
            }"
          >
            <template slot="days">{{ $t("counter.days") }}</template>
            <template slot="hours">{{ $t("counter.hours") }}</template>
            <template slot="minutes">{{ $t("counter.minutes") }}</template>
            <template slot="seconds">{{ $t("counter.seconds") }}</template>
          </counter>
        </div>
      </div>

      <!-- totte bag popup -->
      <TotteBagPopup
        :isVisible="isPopupVisible"
        @close="isPopupVisible = false"
        :type="popupType"
      />

      <div
        class="product-container"
        :class="{ 'hover-disabled': isHoverDisabled }"
        @mouseenter="handleMouseEnter"
      >
        <div
          class="mobile-selected-product left relative"
          :class="{ selected: selectedProduct == 'mini' }"
        >
          <!-- <div
            @click="
              (evt) => {
                evt.stopPropagation();
                selectedProduct = 'vertuo';
              }
            "
            class="back-button block"
            style="
              position: absolute;
              top: 0;
              left: 50%;
              white-space: nowrap;
              transform: translate(-50%, -100%);
            "
            v-html="$t('landingBanner.vertuoPopOffer') + ' >'"
          ></div> -->

          <ImageWrapper
            class="machine"
            :src="selectedEssenza.imgPathPreview"
            alt=""
          />
        </div>
        <!-- left product -->
        <div
          class="left-product-section product-section"
          :class="{
            selected: selectedProduct == 'mini',
            'not-selected': selectedProduct == 'vertuo',
          }"
          @click="handleSelectProduct('mini')"
        >
          <div class="product-card-container">
            <!-- Exclusive Badge -->

            <div
              class="product-badge"
              v-show="selectedEssenza && selectedEssenza.remarks !== ''"
            >
              <div class="badge-circular">
                <div class="badge-text">
                  <p class="badge-line-1">
                    {{ $t("landingBanner.exclusiveBadgeTitle") }}
                  </p>
                  <p class="badge-line-2">
                    {{ $t("landingBanner.exclusiveBadgeSubtitle") }}
                  </p>
                </div>
              </div>
            </div>

            <div
              class="product-card"
              :class="{ selected: selectedProduct != '' }"
              v-vue-aos.once="{
                animationClass: 'animate__animated animate__fadeIn',
              }"
            >
              <!-- Product Content -->
              <div class="product-content">
                <div class="product-content__inner">
                  <!-- Product Info -->
                  <div class="product-info">
                    <h3 class="product-title">
                      {{ $t("landingBanner.productTitle") }}
                    </h3>
                    <h3 class="product-title detail">
                      {{ selectedEssenza.desc }}
                    </h3>

                    <div
                      class="product-detail__wrapper mobile text-left visible-hidden"
                      :class="{ selected: selectedProduct == 'mini' }"
                    >
                      <!-- Specifications List -->
                      <div
                        v-if="
                          selectedEssenza.specf &&
                          selectedEssenza.specf.length > 0
                        "
                        class="specifications-list mb-3"
                      >
                        <ul class="spec-items">
                          <li
                            v-for="(spec, index) in selectedEssenza.specf"
                            :key="index"
                            class="spec-item fz-14"
                          >
                            {{ spec }}
                          </li>
                        </ul>
                      </div>

                      <!-- Color Selection -->
                      <div class="color-selection mb-3 hide-mobile">
                        <!-- Color Selection Label -->
                        <p class="color-selected-text mb-2">
                          <span class="color-label"
                            >{{ $t("colorSelected") }}
                          </span>
                          <span class="color-name">{{
                            selectedEssenza.colorName
                          }}</span>
                        </p>

                        <!-- Color Options -->
                        <div class="color-options d-flex gap-2">
                          <div
                            v-for="(variant, index) in essenzaMiniData"
                            :key="variant.sku"
                            class="color-option"
                            :class="{
                              active: preSelectedEssenza === index,
                            }"
                            @click="selectEssenzaVariant(index)"
                          >
                            <div
                              class="color-circle"
                              :style="{
                                backgroundColor: variant.colorCode,
                              }"
                              :title="variant.colorName"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="prodcut-info-content__row">
                      <!-- left col -->
                      <div
                        class="prodcut-info-content__col--left relative"
                        :class="{ selected: selectedProduct == 'mini' }"
                      >
                        <div
                          class="prodcut-info-machine__wrapper"
                          v-vue-aos.once="{
                            animationClass:
                              'animate__animated animate__fadeInLeft',
                          }"
                          :class="{ selected: selectedProduct == 'mini' }"
                        >
                          <div class="machine">
                            <ImageWrapper
                              class="img"
                              :class="{ selected: selectedProduct == 'mini' }"
                              :src="selectedEssenza.imgPath"
                              alt=""
                            />
                            <ImageWrapper
                              class="previewImg"
                              :class="{ selected: selectedProduct == 'mini' }"
                              :src="selectedEssenza.imgPathPreview"
                              alt=""
                            />
                          </div>
                          <div
                            class="gift"
                            :class="{ selected: selectedProduct == 'mini' }"
                          >
                            <ImageWrapper
                              :src="selectedEssenza.imgGift"
                              alt=""
                            />

                            <div
                              class="giftBut cups"
                              @click="
                                isPopupVisible = true;
                                popupType = 3;
                              "
                            >
                              <ImageWrapper
                                class="img"
                                src="/assets/images/2025/banner_mobile_mini_cups.png"
                                alt=""
                              />
                              <div class="gift-popup-but type1">
                                {{ $t("landingBanner.coffeeCup") }}
                              </div>
                            </div>
                            <div
                              class="giftBut tote"
                              @click="
                                isPopupVisible = true;
                                popupType = 1;
                              "
                            >
                              <ImageWrapper
                                class="img"
                                src="/assets/images/2025/banner_mobile_mini_tote.png"
                                alt=""
                              />
                              <div
                                class="gift-popup-but type2"
                                v-html="$t('landingBanner.ashToteBag')"
                              ></div>
                            </div>
                            <div
                              class="giftBut caps"
                              @click="
                                isPopupVisible = true;
                                popupType = 4;
                              "
                            >
                              <ImageWrapper
                                class="img"
                                src="/assets/images/2025/banner_mobile_mini_caps_2.png"
                                alt=""
                              />
                              <div
                                class="gift-popup-but type4"
                                v-html="$t('landingBanner.coffeeAssortment')"
                              ></div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="product-detail__wrapper text-left visible-hidden"
                        >
                          <!-- Specifications List -->
                          <div
                            v-if="
                              selectedEssenza.specf &&
                              selectedEssenza.specf.length > 0
                            "
                            class="specifications-list mb-3"
                          >
                            <ul class="spec-items">
                              <li
                                v-for="(spec, index) in selectedEssenza.specf"
                                :key="index"
                                class="spec-item fz-14"
                              >
                                {{ spec }}
                              </li>
                            </ul>
                          </div>

                          <!-- Color Selection -->
                          <div class="color-selection mb-3">
                            <!-- Color Selection Label -->
                            <p class="color-selected-text mb-2">
                              <span class="color-label"
                                >{{ $t("colorSelected") }}
                              </span>
                              <span class="color-name">{{
                                selectedEssenza.colorName
                              }}</span>
                            </p>

                            <!-- Color Options -->
                            <div class="color-options d-flex gap-2">
                              <div
                                v-for="(variant, index) in essenzaMiniData"
                                :key="variant.sku"
                                class="color-option"
                                :class="{
                                  active: preSelectedEssenza === index,
                                }"
                                @click="selectEssenzaVariant(index)"
                              >
                                <div
                                  class="color-circle"
                                  :style="{
                                    backgroundColor: variant.colorCode,
                                  }"
                                  :title="variant.colorName"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- right col -->
                      <div class="prodcut-info-content__col--right">
                        <!-- Pricing -->
                        <div class="product-pricing">
                          <div class="price-main fz-48 fw-bold">
                            {{ selectedEssenza.price }}
                          </div>
                          <div class="price-details">
                            <span
                              class="original-price col__black fz-24 fw-light text-decoration-line-through"
                            >
                              {{ selectedEssenza.originalPrice }}
                            </span>
                            <span
                              class="discount-badge bg__discount col__white fz-16 fw-bold"
                            >
                              {{ selectedEssenza.discount }}
                            </span>
                          </div>
                          <div
                            class="product-remarks"
                            v-if="selectedEssenza.remarks"
                          >
                            {{ selectedEssenza.remarks }}
                          </div>
                        </div>
                        <div>
                          <!-- Color Selection -->
                          <div
                            class="color-selection mb-3 hide-desktop"
                            style="margin-top: 16px"
                            :style="{
                              display:
                                selectedProduct === 'mini'
                                  ? 'block'
                                  : 'none!important',
                            }"
                          >
                            <!-- Color Selection Label -->
                            <p class="color-selected-text mb-2">
                              <span class="color-label"
                                >{{ $t("colorSelected") }}
                              </span>
                              <span class="color-name">{{
                                selectedEssenza.colorName
                              }}</span>
                            </p>

                            <!-- Color Options -->
                            <div class="color-options d-flex gap-2">
                              <div
                                v-for="(variant, index) in essenzaMiniData"
                                :key="variant.sku"
                                class="color-option"
                                :class="{
                                  active: preSelectedEssenza === index,
                                }"
                                @click="selectEssenzaVariant(index)"
                              >
                                <div
                                  class="color-circle"
                                  :style="{
                                    backgroundColor: variant.colorCode,
                                  }"
                                  :title="variant.colorName"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Add to Cart Button -->
                        <ShopNowButton
                          :is-selected="selectedProduct === 'mini'"
                          v-show="selectedProduct !== 'mini'"
                        />
                        <div
                          class="product-actions"
                          :class="{ selected: selectedProduct === 'mini' }"
                        >
                          <AddToCart
                            v-for="(variant, index) in essenzaMiniData"
                            :key="'addtocart-essenza-' + variant.sku + index"
                            :id="variant.sku"
                            v-show="preSelectedEssenza === index"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="mobile-gift"
                      :class="{ selected: selectedProduct == 'mini' }"
                    >
                      <div class="left">
                        <div
                          @click="
                            isPopupVisible = true;
                            popupType = 4;
                          "
                        >
                          <ImageWrapper
                            src="/assets/images/2025/banner_mobile_mini_caps_2.png"
                            alt=""
                          />
                          <div
                            class="gift-popup-but type4 block"
                            v-html="$t('landingBanner.coffeeAssortment')"
                          ></div>
                        </div>
                      </div>
                      <div class="right">
                        <div
                          class="relative"
                          @click="
                            isPopupVisible = true;
                            popupType = 1;
                          "
                        >
                          <ImageWrapper
                            src="/assets/images/2025/banner_mobile_mini_tote.png"
                            alt=""
                          />
                          <div
                            class="gift-popup-but type2 block"
                            v-html="$t('landingBanner.ashToteBag')"
                          ></div>
                        </div>
                        <div
                          class="relative"
                          @click="
                            isPopupVisible = true;
                            popupType = 3;
                          "
                        >
                          <ImageWrapper
                            src="/assets/images/2025/banner_mobile_mini_cups.png"
                            alt=""
                          />
                          <div class="gift-popup-but type1 block">
                            {{ $t("landingBanner.coffeeCup") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="product-select-other">
                    <div
                      @click="
                        (evt) => {
                          evt.stopPropagation();
                          selectedProduct = '';
                        }
                      "
                      class="back-button"
                      :class="{ selected: selectedProduct !== '' }"
                      :style="{ top: '-140px' }"
                    >
                      <span v-html="$t('landingBanner.back')"></span>
                    </div>
                    <div
                      @click="
                        (evt) => {
                          evt.stopPropagation();
                          selectedProduct = 'vertuo';
                        }
                      "
                    >
                      <ImageWrapper
                        src="/assets/images/2025/banner_other_but.png"
                        alt=""
                        class="other-button"
                      />
                      <span
                        class="other-button__text"
                        v-html="$t('landingBanner.vertuoPopOffer') + ' >'"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="product-matt"
              v-show="selectedEssenza && selectedEssenza.remarks !== ''"
            >
              <ImageWrapper
                src="/assets/images/banner__mat.png"
                class="mat"
                alt=""
              />
              <div class="product-matt__text">
                {{ selectedEssenza.colorName.toUpperCase() }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedProduct == 'mini'">
          <div
            @click="
              (evt) => {
                evt.stopPropagation();
                selectedProduct = 'vertuo';
              }
            "
            class="back-button mobile-back"
          >
            <span
              class="back-button__text"
              v-html="$t('landingBanner.vertuoPopOffer')"
            ></span>
            <ImageWrapper src="/assets/images/2025/arrow_down.png" alt="" />
          </div>
        </div>

        <div
          class="mobile-selected-product right relative"
          style="padding-top: 30px"
          :class="{ selected: selectedProduct == 'vertuo' }"
        >
          <!-- <div
            @click="
              (evt) => {
                evt.stopPropagation();
                selectedProduct = 'mini';
              }
            "
            class="back-button block"
            style="
              position: absolute;
              top: 0;
              left: 50%;
              white-space: nowrap;
              transform: translateX(-50%);
            "
            v-html="$t('landingBanner.miniOffer')"
          ></div> -->

          <div
            @click="
              (evt) => {
                evt.stopPropagation();
                selectedProduct = 'mini';
              }
            "
            class="back-button mobile-back"
            style="
              position: absolute;
              top: 0;
              left: 50%;
              white-space: nowrap;
              transform: translateX(-50%);
            "
          >
            <span v-html="$t('landingBanner.miniOffer')"></span>
            <ImageWrapper
              src="/assets/images/2025/arrow_down.png"
              alt=""
              style="transform: rotate(180deg) translateY(50%)"
            />
          </div>

          <ImageWrapper
            class="machine"
            :src="selectedVertuoPop.imgPathPreview"
            alt=""
          />
        </div>
        <!-- right product -->
        <div
          class="right-product-section product-section"
          :class="{
            selected: selectedProduct == 'vertuo',
            'not-selected': selectedProduct == 'mini',
          }"
          @click="handleSelectProduct('vertuo')"
        >
          <div class="product-card-container">
            <!-- Exclusive Badge -->

            <div
              class="product-card"
              :class="{ selected: selectedProduct != '' }"
              v-vue-aos.once="{
                animationClass: 'animate__animated animate__fadeIn',
              }"
            >
              <!-- Product Content -->
              <div class="product-content">
                <div class="product-content__inner">
                  <div
                    class="product-select-other"
                    @click="
                      (evt) => {
                        evt.stopPropagation();
                        selectedProduct = 'mini';
                      }
                    "
                  >
                    <div
                      @click="
                        (evt) => {
                          evt.stopPropagation();
                          selectedProduct = '';
                        }
                      "
                      class="back-button"
                      :class="{ selected: selectedProduct !== '' }"
                      :style="{ top: '-158px' }"
                    >
                      {{ $t("landingBanner.back") }}
                    </div>
                    <ImageWrapper
                      src="/assets/images/2025/essenza_mini_black.png"
                      alt=""
                      class="other-button"
                    />
                    <span
                      class="other-button__text"
                      v-html="'< ' + $t('landingBanner.miniOffer')"
                    ></span>
                  </div>

                  <!-- Product Info -->
                  <div class="product-info">
                    <h3 class="product-title">
                      {{ $t("landingBanner.productTitleV") }}
                    </h3>
                    <h3 class="product-title detail">
                      {{ selectedVertuoPop.desc }}
                    </h3>

                    <div
                      class="product-detail__wrapper mobile text-left visible-hidden"
                      :class="{ selected: selectedProduct == 'vertuo' }"
                    >
                      <!-- Specifications List -->
                      <div
                        v-if="
                          selectedVertuoPop.specf &&
                          selectedVertuoPop.specf.length > 0
                        "
                        class="specifications-list mb-3"
                      >
                        <ul class="spec-items">
                          <li
                            v-for="(spec, index) in selectedVertuoPop.specf"
                            :key="index"
                            class="spec-item fz-14"
                          >
                            {{ spec }}
                          </li>
                        </ul>
                      </div>

                      <!-- Color Selection -->
                      <div class="color-selection mb-3 hide-mobile">
                        <!-- Color Selection Label -->
                        <p class="color-selected-text mb-2">
                          <span class="color-label"
                            >{{ $t("colorSelected") }}
                          </span>
                          <span class="color-name">{{
                            selectedVertuoPop.colorName
                          }}</span>
                        </p>

                        <!-- Color Options -->
                        <div class="color-options d-flex gap-2">
                          <div
                            v-for="(variant, index) in vertuoPopData"
                            :key="variant.sku"
                            class="color-option"
                            :class="{
                              active: preSelectedVertuoPop === index,
                            }"
                            @click="selectVertuoPopVariant(index)"
                          >
                            <div
                              class="color-circle"
                              :style="{
                                backgroundColor: variant.colorCode,
                              }"
                              :title="variant.colorName"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="prodcut-info-content__row"
                      :class="{ selected: selectedProduct == 'vertuo' }"
                    >
                      <!-- left col -->
                      <div
                        class="prodcut-info-content__col--left relative"
                        :class="{ selected: selectedProduct == 'vertuo' }"
                      >
                        <div
                          class="prodcut-info-machine__wrapper"
                          v-vue-aos.once="{
                            animationClass:
                              'animate__animated animate__fadeInRight',
                          }"
                          :class="{ selected: selectedProduct == 'vertuo' }"
                        >
                          <div class="machine">
                            <ImageWrapper
                              class="img"
                              :class="{ selected: selectedProduct == 'vertuo' }"
                              :src="selectedVertuoPop.imgPath"
                              alt=""
                            />
                            <ImageWrapper
                              class="previewImg"
                              :class="{ selected: selectedProduct == 'vertuo' }"
                              :src="selectedVertuoPop.imgPathPreview"
                              alt=""
                            />
                          </div>
                          <div
                            class="gift"
                            :class="{ selected: selectedProduct == 'vertuo' }"
                          >
                            <ImageWrapper
                              :src="selectedVertuoPop.imgGift"
                              alt=""
                            />
                            <div
                              class="giftBut cups"
                              @click="
                                isPopupVisible = true;
                                popupType = 3;
                              "
                            >
                              <ImageWrapper
                                class="img"
                                src="/assets/images/2025/banner_mobile_mini_cups.png"
                                alt=""
                              />
                              <div class="gift-popup-but type1">
                                {{ $t("landingBanner.coffeeCup") }}
                              </div>
                            </div>

                            <div
                              class="giftBut tote"
                              @click="
                                isPopupVisible = true;
                                popupType = 2;
                              "
                            >
                              <ImageWrapper
                                src="/assets/images/tote-bag-product-red.png"
                                alt=""
                              />
                              <div
                                class="gift-popup-but type2"
                                v-html="$t('landingBanner.ashToteBag')"
                              ></div>
                            </div>

                            <div
                              class="giftBut caps"
                              @click="
                                isPopupVisible = true;
                                popupType = 5;
                              "
                            >
                              <ImageWrapper
                                class="img"
                                src="/assets/images/2025/banner_mobile_mini_caps_2.png"
                                alt=""
                              />
                              <div
                                class="gift-popup-but type5"
                                v-html="$t('landingBanner.vlCapsAssortment')"
                              ></div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="product-detail__wrapper text-left visible-hidden"
                        >
                          <!-- Specifications List -->
                          <div
                            v-if="
                              selectedVertuoPop.specf &&
                              selectedVertuoPop.specf.length > 0
                            "
                            class="specifications-list mb-3"
                          >
                            <ul class="spec-items">
                              <li
                                v-for="(spec, index) in selectedVertuoPop.specf"
                                :key="index"
                                class="spec-item fz-14"
                              >
                                {{ spec }}
                              </li>
                            </ul>
                          </div>

                          <!-- Color Selection -->
                          <div class="color-selection mb-3">
                            <!-- Color Selection Label -->
                            <p class="color-selected-text mb-2">
                              <span class="color-label"
                                >{{ $t("colorSelected") }}
                              </span>
                              <span class="color-name">{{
                                selectedVertuoPop.colorName
                              }}</span>
                            </p>

                            <!-- Color Options -->
                            <div class="color-options d-flex gap-2">
                              <div
                                v-for="(variant, index) in vertuoPopData"
                                :key="variant.sku"
                                class="color-option"
                                :class="{
                                  active: preSelectedVertuoPop === index,
                                }"
                                @click="selectVertuoPopVariant(index)"
                              >
                                <div
                                  class="color-circle"
                                  :style="{
                                    backgroundColor: variant.colorCode,
                                  }"
                                  :title="variant.colorName"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- right col -->
                      <div class="prodcut-info-content__col--right">
                        <!-- Pricing -->
                        <div class="product-pricing">
                          <div class="price-main fz-48 fw-bold">
                            {{ selectedVertuoPop.price }}
                          </div>
                          <div class="price-details">
                            <span
                              class="original-price col__black fz-24 fw-light text-decoration-line-through"
                            >
                              {{ selectedVertuoPop.originalPrice }}
                            </span>
                            <span
                              class="discount-badge bg__discount col__white fz-16 fw-bold"
                            >
                              {{ selectedVertuoPop.discount }}
                            </span>
                          </div>
                          <div
                            class="product-remarks"
                            style="
                              visibility: hidden;
                              height: 1.2em;
                              overflow: hidden;
                            "
                          >
                            (Special price only for Matt Black version)
                          </div>
                        </div>

                        <div>
                          <!-- Color Selection -->
                          <div
                            class="color-selection mb-3 hide-desktop"
                            style="margin-top: 16px"
                            :style="{
                              display:
                                selectedProduct === 'vertuo'
                                  ? 'block'
                                  : 'none!important',
                            }"
                          >
                            <!-- Color Selection Label -->
                            <p class="color-selected-text mb-2">
                              <span class="color-label"
                                >{{ $t("colorSelected") }}
                              </span>
                              <span class="color-name">{{
                                selectedVertuoPop.colorName
                              }}</span>
                            </p>

                            <!-- Color Options -->
                            <div class="color-options d-flex gap-2">
                              <div
                                v-for="(variant, index) in vertuoPopData"
                                :key="variant.sku"
                                class="color-option"
                                :class="{
                                  active: preSelectedVertuoPop === index,
                                }"
                                @click="selectVertuoPopVariant(index)"
                              >
                                <div
                                  class="color-circle"
                                  :style="{
                                    backgroundColor: variant.colorCode,
                                  }"
                                  :title="variant.colorName"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <ShopNowButton
                          :is-selected="selectedProduct === 'vertuo'"
                          v-show="selectedProduct !== 'vertuo'"
                        />
                        <!-- Add to Cart Button -->
                        <div
                          class="product-actions"
                          :class="{ selected: selectedProduct === 'vertuo' }"
                        >
                          <AddToCart
                            v-for="(variant, index) in vertuoPopData"
                            :key="'addtocart-vertuo-' + variant.sku + index"
                            :id="variant.sku"
                            v-show="preSelectedVertuoPop === index"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="mobile-gift"
                      :class="{ selected: selectedProduct == 'vertuo' }"
                    >
                      <div
                        class="left"
                        @click="
                          isPopupVisible = true;
                          popupType = 5;
                        "
                      >
                        <ImageWrapper
                          src="/assets/images/2025/banner_mobile_vert_caps.png"
                          alt=""
                        />
                        <div
                          class="gift-popup-but type5 block"
                          v-html="$t('landingBanner.vlCapsAssortment')"
                        ></div>
                      </div>
                      <div class="right">
                        <div
                          class="relative"
                          @click="
                            isPopupVisible = true;
                            popupType = 2;
                          "
                        >
                          <ImageWrapper
                            src="/assets/images/2025/banner_mobile_vert_tote.png"
                            alt=""
                          />
                          <div class="gift-popup-but type2 block">
                            ASH LIMITED<br />EDITION TOTE BAG
                          </div>
                        </div>
                        <div
                          class="relative"
                          @click="
                            isPopupVisible = true;
                            popupType = 3;
                          "
                        >
                          <ImageWrapper
                            src="/assets/images/2025/banner_mobile_mini_cups.png"
                            alt=""
                          />
                          <div class="gift-popup-but type1 block">
                            Coffee Cup
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col__black relative" style="margin-bottom: 300px">
        <a @click="isPopupVisible = true"> TOTE BAG (1, 2) | cups (3)</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import TotteBagPopup from "./TotteBagPopup.vue";
import counter from "../atoms/counter.vue";
import { AddToCart } from "../index.js";
import ImageWrapper from "../atoms/ImageWrapper.vue";
import ShopNowButton from "../atoms/ShopNowButton.vue";

export default {
  name: "LandingBanner",

  components: {
    counter,
    TotteBagPopup,
    AddToCart,
    ImageWrapper,
    ShopNowButton,
  },

  data() {
    return {
      selectedProduct: "",
      isPopupVisible: false,
      popupType: 1,
      preSelectedEssenza: 0, // First element (Piano Black)
      preSelectedVertuoPop: 5, // First element (Matte Black)
      isHoverDisabled: false, // Flag to disable hover during animation
      animationTimer: null, // Timer for animation completion
    };
  },

  props: {
    /**
     * End time for the countdown timer
     * @type {Number}
     */
    endTime: {
      type: Number,
      required: true,
    },

    /**
     * Product data for the left product section
     */
    productData: {
      type: Object,
      default: () => ({
        sku: "ESSENZA_MINI_OFFER",
      }),
    },
  },

  inject: ["stage"],

  computed: {
    /**
     * Formatted end time for the countdown timer
     * @returns {String} Formatted end time
     */
    formattedEndTime() {
      const date = new Date(this.endTime);
      return date.toLocaleString();
    },
    /**
     * Get Essenza Mini machine data from locale
     * @returns {Array} Array of Essenza Mini variants
     */
    essenzaMiniData() {
      return this.$t("banner.machine.essenzaMini");
    },

    /**
     * Get Essenza Mini machine data from locale
     * @returns {Array} Array of Essenza Mini variants
     */
    vertuoPopData() {
      return this.$t("banner.machine.vertuoPop");
    },

    /**
     * Get currently selected Essenza Mini variant
     * @returns {Object} Selected Essenza Mini variant data
     */
    selectedEssenza() {
      return (
        this.essenzaMiniData[this.preSelectedEssenza] || this.essenzaMiniData[0]
      );
    },
    /**
     * Get currently selected Vertuo Pop variant
     * @returns {Object} Selected Vertuo Pop variant data
     */
    selectedVertuoPop() {
      return (
        this.vertuoPopData[this.preSelectedVertuoPop] || this.vertuoPopData[0]
      );
    },
  },

  methods: {
    handleSelectProduct(product) {
      // if (this.stage != "inSale") return;
      this.selectedProduct = product;
    },
    /**
     * Handles mouse enter event on product container
     * Clears any existing animation timer and enables hover
     */
    handleMouseEnter() {
      if (this.animationTimer) {
        clearTimeout(this.animationTimer);
        this.animationTimer = null;
      }
      this.isHoverDisabled = false;
    },

    /**
     * Handles mouse leave event on product container
     * Disables hover and sets timer to re-enable after animation completes
     */
    handleMouseLeave() {
      this.isHoverDisabled = true;

      // Re-enable hover after animation duration (300ms as per CSS transition)
      this.animationTimer = setTimeout(() => {
        this.isHoverDisabled = false;
        this.animationTimer = null;
      }, 100);
    },

    /**
     * Handles the selection of an Essenza Mini variant
     * @param {number} index - The index of the selected variant
     */
    selectEssenzaVariant(index) {
      this.preSelectedEssenza = index;
    },
    /**
     * Handles the selection of a Vertuo Pop variant
     * @param {number} index - The index of the selected variant
     */
    selectVertuoPopVariant(index) {
      this.preSelectedVertuoPop = index;
    },

    /**
     * Handles counter end event and reloads the page
     * Called when the countdown timer reaches zero
     */
    handleCounterEnd() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content {
  .product-select-other {
    display: none;
    transition: all 0.3s ease-out;
    position: absolute;
    z-index: 10;
    cursor: pointer;

    .other-button__text {
      font-size: rem(14);
      font-style: normal;
      font-weight: 700;
      line-height: 16px; /* 114.286% */
      text-transform: uppercase;
      color: white;
      position: relative;
    }
  }

  .back-button {
    @include media-breakpoint-up(xl) {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 100;
    }

    display: none;
    font-size: 1rem;
    line-height: 1.13;
    font-weight: bold;
    cursor: pointer;

    &.selected {
      display: block;
    }
  }

  .product-title {
    &.detail {
      display: none;
    }
  }

  .selected {
    .product-title {
      display: none;
      &.detail {
        display: block;
      }
    }
  }

  .product-detail__wrapper {
    min-height: 15.3rem;
    position: relative;

    @include media-breakpoint-down(xl) {
      min-height: 17.3rem;
    }

    @include media-breakpoint-down(md) {
      min-height: 7.3rem;
    }
  }

  .prodcut-info-machine__wrapper {
    display: block;
    position: absolute;
    bottom: 10px;
    aspect-ratio: 532 / 353;
    width: 100%;

    .machine {
      width: 46%;
      bottom: -50%;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      transition: all 0.4s ease-out;

      img {
        width: 100%;
        &.selected {
          visibility: hidden;
        }
      }

      .previewImg {
        position: absolute;
        width: 131%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -40%);
        visibility: hidden;
        &.selected {
          visibility: visible;
        }
      }
    }
    .gift {
      position: absolute;
      width: 191%;
      bottom: -76%;
      left: 59%;
      transform: translateX(-50%);
      transition: all 0.4s ease-out;

      .giftBut {
        display: none;
        position: absolute;
      }

      &.selected {
        .giftBut {
          display: block;

          &:hover {
            cursor: pointer;
          }
        }
      }

      img {
        width: 100%;
        position: relative;
      }
    }

    @include media-breakpoint-down(xl) {
      &.selected {
        display: none;
      }
    }
  }

  .gift-popup-but {
    border-radius: 40px;
    background: rgba(208, 188, 174, 0.7);
    backdrop-filter: blur(5px);
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 114.286% */
    text-transform: uppercase;
    padding: rem(10);
    cursor: pointer;
    display: none;
    white-space: nowrap;

    @include media-breakpoint-down(xl) {
      font-size: rem(12);
    }

    &.type1 {
      position: absolute;
      bottom: 1%;
      left: 37%;
    }

    &.type2 {
      position: absolute;
      bottom: 11%;
      left: -8%;
    }

    &.type4 {
      position: absolute;
      bottom: -22%;
      left: 27%;
    }
  }

  .bg__banner-bg {
    background: url("https://s3.ap-southeast-1.amazonaws.com/nespresso.web/2025double11/assets/images/2025__banner_left_bg.jpg");
    background-size: 100%;
    background-position-y: 100%;

    @include media-breakpoint-down(md) {
      background: linear-gradient(180deg, #793666 24.52%, #3b132f 100%);
      padding-bottom: 40px;
    }
  }

  .banner__top-mobile {
    display: none;

    @include media-breakpoint-down(xl) {
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 13%;
      width: 201%;
      z-index: 10;
    }

    @include media-breakpoint-down(md) {
      bottom: -12%;
      width: 300%;
    }
  }

  .banner__bg {
    @include media-breakpoint-down(xl) {
      display: none;
    }
  }

  .banner__bg-mobile-pattern {
    display: none;
    @include media-breakpoint-down(md) {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .title-wrapper {
    margin-bottom: rem(100);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    @include media-breakpoint-down(xl) {
      flex-direction: column;
      align-items: center;
      margin: auto;
      max-width: rem(768);
    }

    @include media-breakpoint-down(md) {
      .brand-title {
        font-size: rem(24);
      }
      .event-title {
        font-size: rem(32);
      }
      .date-title {
        font-size: rem(16);
      }
    }
  }
  .title-section {
    padding-top: rem(37);
    position: relative;
    z-index: 2;

    @include media-breakpoint-down(xl) {
      padding-bottom: rem(50);
    }

    @include media-breakpoint-down(md) {
      padding-top: rem(20);
      padding-bottom: rem(20);
      position: relative;
      z-index: 100;
    }

    &.title-section--left {
      @include media-breakpoint-down(xl) {
        position: relative;
        z-index: 2;
        padding-bottom: 59px;
      }
    }
  }
  .banner {
    &__bg {
      width: auto;
      // height: rem(560);
      // object-fit: cover;
      object-position: top;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      // aspect-ratio: 18 / 7;

      height: rem(422);
      object-fit: contain;
      aspect-ratio: 1920 / 422;
    }
  }

  .prodcut-info-content {
    &__row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: rem(12);
      width: 100%;
    }
  }

  .right-product-section {
    .prodcut-info-content__row {
      // padding-right: 8%;
    }

    .product-mini-image__wrapper {
      right: 11%;

      .tote-bag-red {
        position: absolute;
        height: 75%;
        bottom: -8%;
        left: 42%;
      }

      .gift-cups {
        left: -60%;
        bottom: -18%;
      }

      .gift-caps2 {
        position: absolute;
        height: 61%;
        bottom: -23%;
        left: 37%;
      }
    }

    .product-title {
      text-align: left !important;
    }

    .prodcut-info-content {
      &__row {
        flex-direction: row-reverse;

        &.selected {
          flex-direction: row;
        }
      }
    }

    .prodcut-info-content__col--right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @include media-breakpoint-down(md) {
        text-align: left;
        .shop-now-btn {
          width: auto;
          display: inline-block;
        }
      }
    }

    .product-detail__wrapper.mobile {
      display: none !important;
      min-height: unset;
    }

    @include media-breakpoint-down(xl) {
      .product-info,
      .product-title {
        text-align: left !important;
      }

      .prodcut-info-content__row {
        flex-direction: column-reverse;
      }

      .product-detail__wrapper.mobile.selected {
        display: block !important;
        opacity: 1;
        visibility: visible;
        z-index: 1;
      }

      .prodcut-info-machine__wrapper {
        width: 70%;
        right: -28%;
      }

      .prodcut-info-content__col--left {
        margin-top: -43%;
        @include media-breakpoint-down(xl) {
          &.selected {
            display: none;
          }
        }
      }
    }

    @include media-breakpoint-down(md) {
      .prodcut-info-machine__wrapper {
        width: 43%;
        right: 5%;
      }
    }
  }

  .product-mini-image {
    max-width: rem(131);
    aspect-ratio: 131 / 297;
    width: 100%;

    &__wrapper {
      width: rem(181);
      margin-top: -13%;
      display: flex;
      justify-content: center;
      margin-bottom: -47%;
      // position: relative;
      position: absolute;
      top: rem(127);

      .tote-bag {
        position: absolute;
        height: 84%;
        bottom: -15%;
        left: -87%;
      }
      .gift-cups {
        position: absolute;
        height: 70%;
        bottom: -24%;
        left: -4%;
      }
      .gift-caps {
        position: absolute;
        height: 72%;
        bottom: -17%;
        left: 63%;
      }
    }
  }

  // Color selection styles
  .color-selection {
    /**
     * Styles for the color selection text label
     */
    .color-selected-text {
      font-family: "Nespresso Lucas", sans-serif;
      font-size: rem(16);
      line-height: 1.2;
      color: color(black);
      margin-bottom: rem(8);
      opacity: 0.8;

      .color-label {
        font-weight: 400;
        @include media-breakpoint-down(md) {
          font-size: rem(12);
        }
      }

      .color-name {
        font-weight: 700;
        @include media-breakpoint-down(md) {
          font-size: rem(12);
        }
      }
    }

    /**
     * Container for color option circles
     */
    .color-options {
      align-items: center;
      gap: rem(8);
    }

    /**
     * Individual color option wrapper with hover and active states
     */
    .color-option {
      cursor: pointer;
      padding: rem(3);
      border-radius: 50%;
      transition: all 0.3s ease;
      border: 1px solid transparent;
      position: relative;

      &.active {
        border-color: #a1a1a1;
        transform: scale(1.1);

        // Add checkmark indicator for selected state
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          border-radius: 100%;
          border: 1px solid #a1a1a1;
        }
      }

      &:hover {
        transform: scale(1.05);
      }

      /**
       * The actual color circle display
       */
      .color-circle {
        width: rem(24);
        height: rem(24);
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.1);
        position: relative;
      }
    }
  }

  // Specifications list styles
  .specifications-list {
    .spec-title {
      color: color(black);
      margin-bottom: rem(8);
    }

    .spec-items {
      list-style: none;
      padding: 0;
      margin: 0;

      .spec-item {
        position: relative;
        padding-left: rem(20);
        margin-bottom: rem(6);
        color: color(darkGray);
        line-height: 1.4;

        @include media-breakpoint-down(md) {
          font-size: rem(14);
          font-weight: 700;
          margin-bottom: 0;
        }

        &:before {
          content: "";
          position: absolute;
          font-weight: bold;
          width: 6px;
          background: black;
          display: block;
          border-radius: 100%;
          aspect-ratio: 1;
          top: 0.7em;
          left: 0.5em;
          transform: translate(-50%, -50%);
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .product {
    &-container {
      display: flex;
      // justify-content: space-between;
      justify-content: center;
      gap: rem(65);
      // height: rem(560);
      // overflow: hidden;

      @include media-breakpoint-down(xl) {
        flex-direction: column;
        margin-top: rem(20);
        gap: rem(30);
        align-items: center;
      }

      @include media-breakpoint-down(md) {
        margin-top: 3rem;
        max-width: 406px;
        margin-left: auto;
        margin-right: auto;
      }

      .product-remarks {
        color: color(black);
        font-size: rem(12);
        line-height: 1.2;
        font-weight: 600;
      }

      .product-section {
        padding: 0;
        transition: all 0.3s ease;
        // padding-top: rem(53);
      }

      .product-card {
        overflow: visible;
        padding-top: 5px;
        padding-bottom: 5px;

        @include media-breakpoint-down(md) {
          padding-top: 1px;
          padding-bottom: 1px;
        }
      }

      // Cross-section hover effects
      // &:hover {
      //   .left-product-section:not(:hover) {
      //     opacity: 0;
      //     width: 0;
      //     height: 0;
      //     overflow: hidden;
      //     flex: 0;
      //   }
      //   .right-product-section:not(:hover) {
      //     opacity: 0;
      //     width: 0;
      //     height: 0;
      //     overflow: hidden;
      //     flex: 0;
      //   }
      // }

      // Disable hover effects when animation is in progress
      // &.hover-disabled {
      //   pointer-events: none;
      //   position: relative;

      //   &::after {
      //     content: "";
      //     position: absolute;
      //     top: 0;
      //     left: 0;
      //     right: 0;
      //     bottom: 0;
      //     background: transparent;
      //     z-index: 999;
      //     pointer-events: auto;
      //   }
      // }
    }
    &-section {
      flex: 1;
      max-width: rem(624);
      align-items: flex-start;
      width: 100%;
    }
  }

  .mobile-selected-product {
    display: none;

    @include media-breakpoint-down(xl) {
      &.selected {
        margin: auto;
        display: block;
        height: rem(259);

        img {
          width: auto;
          height: 100%;
          margin-top: 10px;
          object-fit: contain;
        }
      }
    }

    @include media-breakpoint-down(md) {
      &.selected {
        height: rem(159);
      }
    }
  }

  .mobile-gift {
    display: none;

    @include media-breakpoint-down(xl) {
      &.selected {
        display: flex;
        gap: rem(12);
        margin-top: rem(-70);

        > div:first-child {
          flex-basis: 59%;
          flex-shrink: 0;
          flex-grow: 0;
          padding-top: rem(70);
        }

        .gift-popup-but {
          position: relative;
          text-align: center;
          margin: auto;
          left: unset;
          bottom: unset;
          top: unset;
          right: unset;
        }

        img {
          max-width: 100%;
        }
      }
    }

    @include media-breakpoint-down(md) {
      &.selected {
        margin-top: rem(-16);

        .gift-popup-but {
          font-size: 0.6rem;
          padding: 5px;
        }
      }
    }
  }

  .product-section {
    position: relative;

    @include media-breakpoint-up(xl) {
      &:hover:not(&.selected) {
        transition: all 0.3s ease;
        transform: scale(1.06);
        z-index: 40;
      }

      &.selected {
        .product-select-other {
          display: block;
          transform: translateY(-50%);
          right: -27%;
          top: 50%;
          white-space: nowrap;
        }
      }

      &.not-selected {
        opacity: 0;
        width: 0;
        height: 0;
        overflow: hidden;
        flex: 0;
      }
    }
  }

  .product-card--mobile {
    display: none;

    @include media-breakpoint-down(xl) {
      display: block;

      .product-detail__wrapper {
        visibility: visible !important;
        opacity: 1 !important;
      }
    }
  }

  // Left product section hover interactions
  .left-product-section {
    transition: all 0.3s ease;
    z-index: 10;

    .caps {
      bottom: 34%;
      width: 43%;
      right: -3.4%;
    }

    .cups {
      bottom: 2%;
      width: 25%;
      left: 40%;
    }

    .tote {
      bottom: 18%;
      width: 29%;
      left: 10%;
    }

    .gift-popup-but.type1:before {
      content: "";
      // background: red;
      opacity: 0.5;
      position: absolute;
      width: 110%;
      height: auto;
      bottom: 100%;
      left: 0;
      aspect-ratio: 1.5 / 1;
    }

    .gift-popup-but.type2:before {
      content: "";
      // background: red;
      opacity: 0.5;
      position: absolute;
      width: 68%;
      height: auto;
      bottom: 47%;
      left: 67%;
      aspect-ratio: 1 / 1.8;

      @include media-breakpoint-down(md) {
        left: 0;
        aspect-ratio: 1 / 1.6;
      }
    }

    .product-detail__wrapper.mobile {
      display: none !important;
      min-height: unset;
    }

    @include media-breakpoint-down(xl) {
      .product-info,
      .product-title {
        text-align: left !important;
      }

      .prodcut-info-content__row {
        flex-direction: column-reverse;
      }

      .product-detail__wrapper.mobile.selected {
        display: block !important;
        opacity: 1;
        visibility: visible;
        z-index: 1;
      }

      .prodcut-info-machine__wrapper {
        width: 70%;
        right: -48%;
      }

      .prodcut-info-content__col--left {
        margin-top: -36%;
        @include media-breakpoint-down(xl) {
          &.selected {
            display: none;
          }
        }
      }
    }

    @include media-breakpoint-down(md) {
      .prodcut-info-machine__wrapper {
        width: 43%;
        right: 5%;
      }
    }

    .machine {
      bottom: -28%;
    }

    .product-select-other {
      img {
        width: 128px;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .product-pricing {
      align-items: flex-end;
    }

    .prodcut-info-content__col--right {
      text-align: right;

      @include media-breakpoint-down(md) {
        text-align: left;
        .shop-now-btn {
          width: auto;
          display: inline-block;
        }
      }
    }

    @include media-breakpoint-up(xl) {
      &.selected {
        z-index: 20;
        max-width: rem(718);

        .gift-popup-but {
          display: block;
        }

        .machine {
          width: 46%;
          bottom: -17%;
          left: -104%;
          transform: translateX(-50%) scale(1.2);
          position: absolute;
        }

        .gift {
          left: 30%;
          bottom: -71%;
          // z-index: 100;

          > img {
            visibility: hidden;
          }
        }

        // &:before {
        //   // content: "";
        //   // position: absolute;
        //   // width: 100vw;
        //   // height: 100%;
        //   // right: 0;
        //   // display: block;
        //   // background-color: red;
        //   content: "";
        //   position: absolute;
        //   width: 100vw;
        //   height: 100%;
        //   display: block;
        //   left: 50%;
        //   transform: translateX(-50%);
        // }

        .product-detail__wrapper {
          display: block;
          opacity: 1;
          visibility: visible;
        }

        .product-mini-image__wrapper {
          .product-mini-image {
            visibility: hidden;
          }
        }
      }
    }

    .product-detail__wrapper {
      transition: all 0.3s ease;
      opacity: 0;
      visibility: hidden;
    }

    // .product-mini-image__wrapper {
    //   .product-mini-image,
    //   .tote-bag,
    //   .gift-caps,
    //   .gift-cups {
    //     transition: visibility 0.3s ease;
    //   }
    // }
  }

  // Left product section transition
  .left-product-section {
    transition: all 0.3s ease;
  }

  // Right product section hover interactions
  .right-product-section {
    transition: all 0.3s ease;
    z-index: 10;

    .caps {
      .gift-popup-but {
      }
    }

    .cups {
      bottom: 32%;
      width: 28%;
      left: -20%;

      .gift-popup-but {
        bottom: -17%;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .tote {
      bottom: 34%;
      width: 43%;
      left: 65%;

      .gift-popup-but {
        bottom: -17%;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .caps {
      width: 50%;
      bottom: 27%;
      left: 14%;

      .gift-popup-but {
        width: 226px;
        transform: translateX(-50%);
        left: 50%;
        position: absolute;
      }
    }

    // .gift-popup-but.type1:before {
    //   content: "";
    //   // background: red;
    //   opacity: 0.5;
    //   position: absolute;
    //   width: 110%;
    //   height: auto;
    //   bottom: 100%;
    //   left: -12%;
    //   aspect-ratio: 1.5 / 1;
    // }

    // .gift-popup-but.type5 {
    //   position: absolute;
    //   bottom: -22%;
    //   left: 27%;
    // }

    // .gift-popup-but.type2:before {
    //   content: "";
    //   // background: red;
    //   opacity: 0.5;
    //   position: absolute;
    //   width: 82%;
    //   height: auto;
    //   bottom: 47%;
    //   left: 5%;
    //   aspect-ratio: 1 / 1.3;

    //   // @include media-breakpoint-down(md) {
    //   //   left: 0;
    //   //   aspect-ratio: 1 / 1.6;
    //   // }
    // }

    .machine {
      bottom: -14%;

      .previewImg.selected {
        height: 100%;
        width: auto;
        transform: translate(-43%, -58%);
      }
    }

    .product-select-other {
      right: 110% !important;
    }

    .gift {
      width: 137%;
      left: 57%;
      bottom: -72%;
    }

    .product-select-other {
      .other-button {
        width: rem(128);
        opacity: 0.5;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    @include media-breakpoint-up(xl) {
      &.selected {
        // transform: translateX(-50%);
        z-index: 20;
        max-width: rem(718);

        .gift-popup-but {
          display: block;

          // &.type1 {
          //   bottom: 13%;
          //   left: 15%;
          // }

          // &.type2 {
          //   bottom: 33%;
          //   left: 62%;
          // }
        }

        .machine {
          bottom: -11%;
          // left: 177%;
          left: 282%;
        }

        .gift {
          left: 61%;
          bottom: -89%;

          > img {
            visibility: hidden;
          }
        }

        .product-detail__wrapper {
          display: block;
          opacity: 1;
          visibility: visible;
        }

        .product-mini-image__wrapper {
          .product-mini-image {
            visibility: hidden;
          }
        }

        // Fade out left section when right section is hovered
      }
    }

    .product-detail__wrapper {
      transition: all 0.3s ease;
      opacity: 0;
      visibility: hidden;
    }

    // .product-mini-image__wrapper {
    //   .product-mini-image,
    //   .tote-bag-red,
    //   .gift-caps2,
    //   .gift-cups {
    //     transition: visibility 0.3s ease;
    //   }
    // }
  }

  .product-matt {
    .mat {
      width: rem(106);
      height: rem(108);

      @include media-breakpoint-down(md) {
        width: rem(68);
        height: rem(67);
      }
    }

    position: absolute;
    top: -6px;
    left: -6px;
    z-index: 3;

    &__text {
      position: absolute;
      top: 36%;
      left: 36%;
      transform: translate(-50%, -50%) rotate(-45deg);
      font-size: rem(14);
      font-weight: 600;
      color: color(white);
      text-align: center;
      white-space: nowrap;

      @include media-breakpoint-down(md) {
        font-size: rem(9);
      }
    }
  }

  .product-badge {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
    transform: translate(50%, -50%);

    @include media-breakpoint-down(md) {
      transform: translate(21%, -50%);
    }

    .badge-circular {
      position: relative;
      width: rem(106);
      aspect-ratio: 1;
      background: linear-gradient(150deg, #edd3a3 18.3%, #cea84e 86.98%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      @include media-breakpoint-down(md) {
        width: rem(66);
      }

      .badge-text {
        text-align: center;
        color: color(black);

        .badge-line-1 {
          font-weight: 700;
          font-size: rem(16);
          line-height: rem(20);
          text-transform: uppercase;
          margin: 0;
          margin-bottom: rem(2);

          @include media-breakpoint-down(md) {
            font-size: rem(12);
            line-height: 1.1em;
          }
        }

        .badge-line-2 {
          font-weight: 400;
          font-size: rem(14);
          line-height: rem(16);
          margin: 0;
          @include media-breakpoint-down(md) {
            font-size: rem(10);
            line-height: 1.1em;
          }
        }
      }
    }
  }

  // Left Product Section Styles
  .product-section {
    .product-card-container {
      width: 100%;

      &:after {
        content: "";
        width: 100%;
        display: block;
        height: rem(100);
        @include media-breakpoint-down(xl) {
          height: 0;
        }
      }

      .product-card {
        @include media-breakpoint-up(xl) {
          &:not(.selected) {
            cursor: pointer;
          }
        }

        // position: relative;
        // background: color(whiteAbs);
        // border-radius: rem(16);
        // overflow: hidden;
        // box-shadow: 0 rem(8) rem(32) rgba( 0, 0, 0, 0.1);
        // transition:
        //   transform 0.3s ease,
        //   box-shadow 0.3s ease;

        .product-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          z-index: 1;
        }

        .product-pricing {
          display: flex;
          flex-direction: column;
          gap: rem(8);
          align-items: center;

          @include media-breakpoint-down(md) {
            align-items: flex-start;
            gap: rem(4);
          }

          .price-main {
            color: color(black);
            font-size: rem(48);
            margin: 0;
            line-height: 1;

            @include media-breakpoint-down(md) {
              font-size: rem(32);
            }
          }

          .price-details {
            display: flex;
            align-items: center;
            gap: rem(12);

            @include media-breakpoint-down(md) {
              .original-price {
                font-size: rem(14);
              }
            }

            .discount-badge {
              padding: rem(8.5) rem(5.5);
              font-size: rem(16);
              font-weight: 700;

              @include media-breakpoint-down(md) {
                font-size: rem(14);
                padding: rem(5);
              }
            }
          }
        }

        .product-content {
          position: relative;
          z-index: 2;
          padding: rem(24);

          @include media-breakpoint-down(md) {
            padding: rem(16);
          }

          .product-content__inner {
            display: flex;
            flex-direction: column;
            gap: rem(20);
            text-align: center;
            max-width: 35.5rem;

            .product-images {
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: rem(16);
              margin-top: rem(32);

              .product-main-image {
                .main-product-img {
                  max-width: rem(200);
                  height: auto;
                  object-fit: contain;
                }
              }

              .product-accessories {
                display: flex;
                justify-content: center;
                gap: rem(12);
                flex-wrap: wrap;

                .accessory-img {
                  max-width: rem(60);
                  height: auto;
                  object-fit: contain;
                  opacity: 0.8;
                  transition: opacity 0.3s ease;

                  &:hover {
                    opacity: 1;
                  }

                  &.coffee-sleeves {
                    max-width: rem(50);
                  }

                  &.barista-mixologist {
                    max-width: rem(70);
                  }

                  &.tote-bag {
                    max-width: rem(55);
                  }
                }
              }
            }
          }
        }

        .product-info {
          display: flex;
          flex-direction: column;
          gap: rem(16);
          text-align: center;
          width: 100%;
        }
        .product-title {
          margin: 0;
          line-height: 1.2;
          color: #4c2840;
          font-size: rem(32);
          letter-spacing: 3.2px;
          text-transform: uppercase;
          text-align: right;

          @include media-breakpoint-down(md) {
            font-size: rem(17);
          }
        }

        .product-description {
          margin: 0;
          line-height: 1.4;
          opacity: 0.8;
        }

        .product-actions {
          color: black;
          margin-top: rem(8);
          display: none;
          &.selected {
            display: block;
          }
        }
      }
    }

    // Responsive Design
    @include media-breakpoint-down(md) {
      .product-card-container {
        // .product-card {
        //   .product-content {
        //     padding: rem(16);

        //     .product-content__inner {
        //       .product-images {
        //         .product-main-image {
        //           .main-product-img {
        //             max-width: rem(150);
        //           }
        //         }

        //         .product-accessories {
        //           .accessory-img {
        //             max-width: rem(40);

        //             &.coffee-sleeves {
        //               max-width: rem(35);
        //             }

        //             &.barista-mixologist {
        //               max-width: rem(50);
        //             }

        //             &.tote-bag {
        //               max-width: rem(40);
        //             }
        //           }
        //         }
        //       }

        //       .product-info {
        //         .product-title {
        //           font-size: rem(24);
        //         }

        //         .product-pricing {
        //           .price-main {
        //             font-size: rem(36);
        //           }

        //           .price-details {
        //             .original-price {
        //               font-size: rem(18);
        //             }
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
